const SubstackEmbed = () => {
  return (
    <section className="py-3">
      <div className="container">
        <div className="row justify-content-center mb-4">
          <div className="col-12">
            <h2 className="text-black font-bold text-uppercase fs-4">
              Subscribe to My Substack
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="embed-responsive embed-responsive-16by9">
              <iframe
                title="Substack Newsletter Signup Form"
                className="embed-responsive-item"
                // 🛑 FIX IS HERE: Use the /embed URL instead of the post URL
                src="https://brandacumen.substack.com/embed" 
                frameBorder="0"
                scrolling="no"
                // You may also need to adjust styling for a form instead of a 16:9 video ratio
                height="300px" // Adjust height to fit the form
                width="100%"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubstackEmbed;